import React from 'react'
import { Outlet } from 'react-router-dom'
import Sidebar from '../ui/Sidebar'

function DashboardLayout() {
  return (
    <div className="min-h-screen bg-gray-50 flex">
      <Sidebar />
      <main className="flex-1 overflow-y-auto">
        <div className="container-custom py-8">
          <Outlet />
        </div>
      </main>
    </div>
  )
}

export default DashboardLayout